import { render, staticRenderFns } from "./TabAbrBci.vue?vue&type=template&id=c68b9708&scoped=true&"
import script from "./TabAbrBci.vue?vue&type=script&lang=js&"
export * from "./TabAbrBci.vue?vue&type=script&lang=js&"
import style0 from "./TabAbrBci.vue?vue&type=style&index=0&id=c68b9708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68b9708",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
